import React from "react";

import { UnderwritingQuestionsForm } from "@covertree/new-business-forms";
import { theme } from "@covertree/theme";
import { ConditionData } from "@covertree/types";
import { FormToggleCard } from "@covertree/ui";

interface ConditionCardProps {
  isSelected: boolean;
  condition: ConditionData;
  conditionKey: keyof UnderwritingQuestionsForm;
  setModalCondition(condition: ConditionData, hasAnswerChanged?: boolean): void;
  onToggle(value: boolean): void;
}

export function ConditionCard({
  isSelected,
  condition,
  conditionKey,
  setModalCondition,
  onToggle,
}: ConditionCardProps) {
  const { title, image, helpText, tooltip, getContent } = condition;

  const handleToggle = React.useCallback(() => {
    if (getContent && !isSelected) {
      setModalCondition(condition, true);
    }

    onToggle(!isSelected);
  }, [getContent, onToggle, isSelected]);

  const content = React.useMemo(
    () =>
      getContent?.(
        conditionKey,
        () => {
          setModalCondition(condition);
        },
        !isSelected
      ),
    [conditionKey, getContent, isSelected]
  );

  return (
    <FormToggleCard
      title={title}
      subheader={helpText}
      tooltip={tooltip}
      image={image}
      content={content}
      onToggle={handleToggle}
      checked={isSelected}
      checkedCustomStyles={{
        backgroundColor: theme.palette.secondary.contrastText,
      }}
      subheaderVariant="grey"
      switchLabels
    />
  );
}
